module.exports = __webpack_public_path__ + "img/expand_less-24px.f5dc117a.svg";